import React from 'react'
import { Route, Redirect } from 'react-router-dom';
// import { CognitoJwtVerifier } from "aws-jwt-verify"

var isAuthentic = false;
const PrivateRoute = ({ component: Component, ...rest }) => {
    const body = localStorage.getItem('accessToken');    
    if(body != null) {
        isAuthentic = true;
    }
    
    return (
        <Route {...rest} render={props => (isAuthentic ? <Component {...props} /> : <Redirect to="/" />)} />
    )
}

export default PrivateRoute